/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
export type AlertSeverity = "ERROR" | "INFO" | "SUCCESS" | "WARNING";
import type { FragmentReference } from "relay-runtime";
declare export opaque type MoveItems_change$ref: FragmentReference;
declare export opaque type MoveItems_change$fragmentType: MoveItems_change$ref;
export type MoveItems_change = {|
  +id: string,
  +databaseId: string,
  +command: string,
  +type: string,
  +alerts: $ReadOnlyArray<{|
    +path: ?string,
    +message: string,
    +severity: AlertSeverity,
  |}>,
  +role?: ?{|
    +databaseId: string,
    +circlePolicies: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +databaseId: string,
          +displayName: string,
          +resourcePath: any,
        |}
      |}>
    |},
    +circleRoles: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +databaseId: string,
          +displayName: string,
          +resourcePath: any,
        |}
      |}>
    |},
  |},
  +childSupportedRole?: ?{|
    +databaseId: string,
    +localizedName: string,
    +circlePolicies: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +databaseId: string,
          +displayName: string,
          +resourcePath: any,
        |}
      |}>
    |},
    +circleRoles: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +databaseId: string,
          +displayName: string,
          +resourcePath: any,
        |}
      |}>
    |},
  |},
  +roleHasBeenRemoved?: boolean,
  +policiesToMoveUp?: $ReadOnlyArray<{|
    +databaseId: string
  |}>,
  +policiesToMoveDown?: $ReadOnlyArray<{|
    +databaseId: string
  |}>,
  +rolesToMoveUp?: $ReadOnlyArray<{|
    +databaseId: string
  |}>,
  +rolesToMoveDown?: $ReadOnlyArray<{|
    +databaseId: string
  |}>,
  +$refType: MoveItems_change$ref,
|};
export type MoveItems_change$data = MoveItems_change;
export type MoveItems_change$key = {
  +$data?: MoveItems_change$data,
  +$fragmentRefs: MoveItems_change$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "resourcePath",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "PolicyConnection",
  "kind": "LinkedField",
  "name": "circlePolicies",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PolicyEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Policy",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": "displayName",
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "RoleConnection",
  "kind": "LinkedField",
  "name": "circleRoles",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RoleEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Role",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": "displayName",
              "args": null,
              "kind": "ScalarField",
              "name": "localizedName",
              "storageKey": null
            },
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MoveItems_change",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "command",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Alert",
      "kind": "LinkedField",
      "name": "alerts",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "path",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "message",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "severity",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Role",
          "kind": "LinkedField",
          "name": "role",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v2/*: any*/),
            (v3/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Role",
          "kind": "LinkedField",
          "name": "childSupportedRole",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "localizedName",
              "storageKey": null
            },
            (v2/*: any*/),
            (v3/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "roleHasBeenRemoved",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Policy",
          "kind": "LinkedField",
          "name": "policiesToMoveUp",
          "plural": true,
          "selections": (v4/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Policy",
          "kind": "LinkedField",
          "name": "policiesToMoveDown",
          "plural": true,
          "selections": (v4/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Role",
          "kind": "LinkedField",
          "name": "rolesToMoveUp",
          "plural": true,
          "selections": (v4/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Role",
          "kind": "LinkedField",
          "name": "rolesToMoveDown",
          "plural": true,
          "selections": (v4/*: any*/),
          "storageKey": null
        }
      ],
      "type": "MoveItemsChange",
      "abstractKey": null
    }
  ],
  "type": "DescribeChangeable",
  "abstractKey": "__isDescribeChangeable"
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c078ed3dc9732f73bf59e20785935e9a';

module.exports = node;
